import React, { useState, useEffect } from 'react'
import {
  Panel,
  IconButton,
  Icon,
  Message,
  Form,
  Row,
  ControlLabel,
  Uploader,
  Button,
  Table,
  ButtonGroup,
  Modal,
} from 'rsuite'
import CKEditor from 'ckeditor4-react'
import AppContext from '../../../context/AppContext'
import CustomIconMessageInfo from '../../CustomIconMessageInfo'
import {
  getMaxLengthData,
  isImageOrPdf,
  isSupportFileType,
  isValidators,
  requiredFiled,
} from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import {
  getFilesForm0,
  uploadFilesForm0,
  editFileNameForm0,
  deleteFilesForm0,
  changeAttachmentBackgroundSeqNo,
} from '../../../redux/actions/background'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../utils/loading'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import TooltipButton from '../../../components/buttons/TooltipButton'

export default function BackgroundForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  // handleDeleteFile,
}) {
  const { Column, HeaderCell, Cell } = Table
  const [schema, setSchema] = useState(_schema)
  const [fileList, setFileList] = useState([])
  const [uploadfileList, setUploadfileList] = useState([])
  const [deleteFile, setDeleteFile] = useState()
  const [mapFileData, setMapFileData] = useState([])

  const [insertFileToContenErr, setInsertFileToContenErr] = useState()

  const [loading, setLoading] = useState(false)

  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [fileTypeError, setFileTypeError] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const contextValue = React.useContext(AppContext)
  // schema.editorData.name
  const maxLength = getMaxLengthData(schema.editorData?.validators)?.value
  const [textLength, setTextLength] = useState(schema.editorData?.value?.length || 0)
  const [isOverSize, setIsOverSize] = useState(false)
  const [isNotSupportType, setIsNotSupportType] = useState(false)

  const defaultSupportType = '.jpg, .jpeg, .png'
  const defaultMaxFileSize = 5

  // console.log(maxLength, textLength)

  useEffect(() => {
    setSchema(_schema)
    setFileList(_schema.fileList ? _schema.fileList : [])
    setMapFileData(
      _schema.mapFileData ? _schema.mapFileData.filter((e) => e.link != null) || [] : []
    )
    setValue(
      'mapFileData',
      _schema.mapFileData ? _schema.mapFileData.filter((e) => e.link != null) || [] : []
    )
  }, [_schema])

  const styles = {
    lineHeight: '90px',
    backgroundColor: contextValue.theme[0] == 'dark' ? '#1a1d24' : '#f7f7f7',
  }

  const onEditorChange = (evt) => {
    const data = evt.editor.getData()
    const text = evt.editor.document.getBody().getText()
    if (data.length > 0) {
      setValue(schema.editorData.name, data)
      clearErrors(schema.editorData.name)
      setTextLength(text.length)
    } else {
      setValue(schema.editorData.name)
      setTextLength(0)
    }
  }

  const handleInsetFileToContent = (file) => {
    setInsertFileToContenErr()

    var editor
    for (var instanceName in CKEDITOR.instances) {
      editor = CKEDITOR.instances[instanceName]
    }
    var selectText = editor.getSelection().getSelectedText()

    // console.log('selectText length ', selectText.trim().length)
    // console.log('selectText ', selectText)
    selectText = selectText?.replaceAll(' ', '')
    if (selectText.length > 0) {
      if (selectText.includes('[') || selectText.includes(']')) {
        setInsertFileToContenErr(`ไม่สามารถใช้ '[' หรือ ']' เป็นข้อความเชื่อมไฟล์`)
      } else {
        let key = '[[' + selectText + ']]'
        let mapPath = [...mapFileData]
        let duplicate = false
        mapPath.forEach((item) => {
          if (key == item.key) {
            duplicate = true
          }
        })

        if (duplicate) {
          setInsertFileToContenErr(
            `ข้อความ '${selectText}' มีการใช้งานไปแล้ว ไม่สามารถใช้ข้อความเดิมซ้ำ`
          )
        } else {
          var obj = { id: file.id, key: key }

          mapPath.push(obj)

          setMapFileData(mapPath)
          setValue('mapFileData', mapPath)

          // console.log('key=', key,' , mapPath=',mapPath)

          editor.insertHtml(` ${key} `)
        }
      }
    } else {
      setInsertFileToContenErr(`กรุณาเลือกข้อความที่ต้องการแทรกไฟล์`)
    }
  }

  const reMapFileDataAndEditer = (fileId) => {
    // console.log('File', fileId)
    var data = getValues(schema.editorData.name)

    let mapFileList = [...mapFileData]

    var key

    mapFileData.forEach((item, index) => {
      if (item.id.includes(fileId)) {
        key = item.key
        mapFileList.splice(index, 1)
        return
      }
    })

    // console.log('key' + key + 'key')
    if (key) {
      var text = key.substring(2, key.length - 2)
      // console.log('text' + text + 'text')
      var res = data.replace(key, text)
      setMapFileData(mapFileList)
      setValue('mapFileData', mapFileList)
      setValue(schema.editorData.name, res)
    }
  }

  const handleUpload = async (request) => {
    startLoading()
    setLoading(true)
    setIsUploadErr()
    try {
      console.log('upload')
      const response = await uploadFilesForm0(projectId, request)

      console.log('response', response)
      if (response) {
        let _schema = schema
        _schema.fileList = response
        setSchema(_schema)
        setFileList(response)
        setUploadfileList([])
        setIsUploadErr(false)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setLoading(false)
    doneLoading()
  }

  const handleDelete = async (fileId) => {
    startLoading()
    setLoading(true)
    setIsDeleteError()
    try {
      console.log('call delete file.')
      const status = await deleteFilesForm0(projectId, fileId)
      if (status === 200) {
        console.log('call get file.')
        const response = await getFilesForm0(projectId)
        // console.log('result', response)
        let _schema = schema
        _schema.fileList = response
        reMapFileDataAndEditer(fileId)
        setSchema(_schema)
        setFileList(response)
        setIsDeleteError(false)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setLoading(false)
    doneLoading()
  }

  const onUpload = () => {
    console.log('onUpload')

    var formData = new FormData()

    uploadfileList?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    handleUpload(formData)
  }

  const onUploaderChange = (files) => {
    let file = files[files.length - 1]

    let isSupportSize = true
    let isSupportType = isSupportFileType(
      file?.blobFile.type,
      schema.fileType || defaultSupportType
    )

    let maxSize = schema.fileSize || defaultMaxFileSize

    isSupportSize = file?.blobFile.size <= maxSize * 1024 * 1024
    setIsOverSize(!isSupportSize)

    setIsNotSupportType(!isSupportType)

    // console.log('isSupportType', isSupportType, 'isSupportSize', isSupportSize)

    if (!file || (isSupportType && isSupportSize)) {
      setUploadfileList(files)
      setFileTypeError(false)
    } else {
      files.splice(files.length - 1, 1)
      setUploadfileList(uploadfileList)
      setFileTypeError(true)
    }
  }

  const onChangSeqNo = async (data, seqNo) => {
    startLoading()
    // setIsLoading(true)
    setIsUploadErr()
    try {
      // console.log('onChangSeqNo')
      const response = await changeAttachmentBackgroundSeqNo(projectId, data.id, seqNo)
      // console.log('onChangSeqNo response', response)

      if (response.success) {
        setFileList(response.model)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    // setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel>
        {schema.description && (
          <Row style={{ marginTop: 10 }}>
            <CustomAlertMessageInfo contents={schema.description} />
          </Row>
        )}

        {schema.message && (
          <Row style={{ marginTop: 10 }}>
            {schema.message.map((item, index) => {
              return (
                <Message
                  style={{ fontSize: '1rem' }}
                  showIcon
                  type={item.type}
                  description={item.description}
                  key={index}
                />
              )
            })}
          </Row>
        )}

        <Form fluid style={{ marginTop: 10 }}>
          <Controller
            key={'mapFileData'}
            name={'mapFileData'}
            control={control}
            defaultValue={mapFileData}
          />

          <Row style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[schema.editorData.name]} />
            {schema.editorData.label && (
              <ControlLabel>
                {requiredFiled(schema.editorData.validators, schema.editorData.label)}
              </ControlLabel>
            )}

            {schema.editorData.description && (
              <CustomIconMessageInfo contents={schema.editorData.description} />
            )}

            <Controller
              key={schema.editorData.name}
              name={schema.editorData.name}
              control={control}
              rules={isValidators(schema.editorData.validators)}
              defaultValue={schema.editorData.value}
              render={(props) => {
                return (
                  <CKEditor
                    key="editorData"
                    name="editorData"
                    data={props.value}
                    style={{ marginTop: 10 }}
                    config={{
                      versionCheck: false,
                      toolbar: [['Undo', 'Redo', 'Bold', 'Italic', 'Maximize']],
                      contentsCss: [
                        'https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;600&display=swap',
                        'body { font-size: "1rem"; font-family: "Sarabun", sans-serif; }',
                      ],
                    }}
                    onChange={onEditorChange}
                  />
                )
              }}
            />
          </Row>
          <ShowLimitLength textLength={textLength} maxLength={maxLength} />
        </Form>
        {insertFileToContenErr && (
          <Row style={{ marginTop: 10 }}>
            <Message showIcon type="error" description={insertFileToContenErr} />
          </Row>
        )}
        {isDeleteError && (
          <Row style={{ marginTop: 10 }}>
            <Message showIcon type="error" description={`ลบไฟล์ไม่สำเร็จ`} />
          </Row>
        )}
        <Row style={{ marginTop: 10 }}>
          <Table autoHeight={fileList.length < 5} height={300} wordWrap data={fileList}>
            <Column width={100} align="center" fixed>
              <HeaderCell>ไฟล์ที่</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>
            <Column width={100} align="center" fixed>
              <HeaderCell>จัดลำดับ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return (
                    <ButtonGroup>
                      {rowData.isDownSeqNo && (
                        <TooltipButton
                          icon="arrow-circle-up"
                          tooltip={`เลื่อนขึ้น`}
                          disabled={loading}
                          onClick={(e) => onChangSeqNo(rowData, rowData.seqNo - 1)}
                        ></TooltipButton>
                      )}
                      {rowData.isUpSeqNo && (
                        <TooltipButton
                          icon="arrow-circle-down"
                          tooltip={`เลื่อนลง`}
                          disabled={loading}
                          onClick={(e) => onChangSeqNo(rowData, rowData.seqNo + 1)}
                        ></TooltipButton>
                      )}
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
            <Column flexGrow={1} fixed>
              <HeaderCell>ชื่อไฟล์</HeaderCell>
              <Cell dataKey="name" />
            </Column>

            <Column width={150} align="center" fixed="right">
              <HeaderCell>แทรกไฟล์ไปยังเนื้อหา</HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="toggle-up" className="bt-gost-icon-radius" />}
                        onClick={(e) => handleInsetFileToContent(rowData)}
                      />
                      {/* แทรกไฟล์ไปยังเนื้อหา
                      </IconButton> */}
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
            <Column width={60} align="center" fixed="right">
              <HeaderCell></HeaderCell>

              <Cell>
                {(rowData, index) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash-o" className="bt-gost-icon-radius-cancel" />}
                        onClick={(e) => setDeleteFile(rowData)}
                      />
                      {/* ลบไฟล์
                      </IconButton> */}
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <p>แนบไฟล์</p>
          <Message
            showIcon
            type="info"
            description={`ชนิดที่รองรับ : ${
              schema.fileType || defaultSupportType
            } ${`, ขนาดไฟล์ไม่เกิน ${schema.fileSize || defaultMaxFileSize} MB`}`}
            style={{ marginBottom: 10 }}
          />

          {fileTypeError && (
            <Message
              style={{ marginBottom: 10 }}
              closable
              onClose={() => {
                setFileTypeError(false)
              }}
              showIcon
              type="error"
              // description="อัพโหลดไฟล์เป็นรูปภาพหรือ PDF เท่านั้น *** ชนิดที่รองรับ png , jpeg , jpg , pdf ***"
              description={`${
                isNotSupportType
                  ? `อัพโหลดไฟล์ได้เฉพาะชนิดที่รองรับเท่านั้น *** ชนิดที่รองรับ ${
                      schema.fileType || defaultSupportType
                    } ***`
                  : ''
              }  ${isOverSize ? ` ขนาดไฟล์เกิน ${schema.fileSize || defaultMaxFileSize} MB ` : ''}`}
            />
          )}
          <Uploader
            autoUpload={false}
            listType="picture-text"
            fileList={uploadfileList}
            onChange={(files) => {
              onUploaderChange(files)
            }}
            draggable
            accept={defaultSupportType}
          >
            <div style={{ lineHeight: '100px' }}>
              <Icon size="4x" icon="upload2" />
              <small
                style={{
                  marginTop: '-70px',
                  display: 'block',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
              </small>
            </div>
          </Uploader>
        </Row>

        {isUploadErr && (
          <Row style={{ marginTop: 10 }}>
            <Message showIcon type="error" description={`อัพโหลดไฟล์ไม่สำเร็จ`} />
          </Row>
        )}

        {uploadfileList?.length > 0 && (
          <Row style={{ marginTop: 10 }}>
            <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon="upload2" className="bt-gost-icon-radius" />}
              onClick={(e) => onUpload()}
              style={{ marginRight: 5 }}
              disabled={loading}
            >
              {`อัพโหลด`}
            </IconButton>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={
                <Icon appearance="ghost" icon={'close'} className="bt-gost-icon-radius-cancel" />
              }
              onClick={(e) => {
                setUploadfileList([])
                setIsUploadErr(false)
                setIsDeleteError(false)
                setFileTypeError(false)
              }}
              style={{ marginRight: 5 }}
              disabled={loading}
            >
              {`ยกเลิก`}
            </IconButton>
          </Row>
        )}
      </Panel>

      <Modal
        show={deleteFile ? true : false}
        onHide={(e) => {
          setDeleteFile('')
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{`ยืนยันการลบไฟล์ ${deleteFile?.name || ''}`}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              handleDelete(deleteFile.id)
              setDeleteFile('')
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setDeleteFile('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
